import { SVGProps } from 'react';

const Expand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 15 6 6m-5 0h5v-5m-6-7 6-6m-5 0h5v5M8 21H3v-5m0 5 6-6M8 3H3v5m0-5 6 6"
    />
  </svg>
);
export default Expand;
